// removed by extract-text-webpack-plugin
module.exports = {"Login":"Login__1Ub__X6y61lt","logo":"logo__3bgKQsIsA-Xc","greeting":"greeting__3-uiN2lVM-AP","tagline":"tagline__2jtun3XjKp_D","loginError":"loginError__QQwb4mWkBadr"};